export enum AccountPaymentMethod {
  Card,
  Ach,
  EuroDirectDebit,
}
